<!-- Environment Warning Banner (hidden in production) -->
<sdk-environment-banner [mode]="environmentMode" />

<!-- Main Content Area -->
<div class="flex-1 overflow-hidden">
  <router-outlet />
</div>

<!-- Global Loading Overlay -->
<sdk-loader />
